export default __webpack_public_path__ + "static/media/7.74133a20.jpg";